module.exports = __webpack_public_path__ + "img/cl-rounded.3689975f.png";